module.exports = __webpack_public_path__ + "img/supplement.febe8674.png";